"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostModelToJSON = exports.CostModelFromJSONTyped = exports.CostModelFromJSON = exports.CostModel = void 0;
/**
 * Method used to determine how advertisers are charged for their ad campaigns.
 * - "CPM": Cost Per Thousand Impressions.
 * - "CPCL": Cost Per Thousand Listens.
 *
 * @export
 */
exports.CostModel = {
    Cpd: 'CPD',
    Cpm: 'CPM',
    Cpcl: 'CPCL',
    Fcpm: 'FCPM',
    Cpr: 'CPR',
    Cpc: 'CPC'
};
function CostModelFromJSON(json) {
    return CostModelFromJSONTyped(json, false);
}
exports.CostModelFromJSON = CostModelFromJSON;
function CostModelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CostModelFromJSONTyped = CostModelFromJSONTyped;
function CostModelToJSON(value) {
    return value;
}
exports.CostModelToJSON = CostModelToJSON;
